import { SagaIterator } from '@redux-saga/core'
import { PayloadAction } from '@reduxjs/toolkit'
import { call, put, takeEvery } from 'redux-saga/effects'

import { loginCall } from 'features/account/api'
import { loginActions } from 'features/account/store/login.slice'
import { LoginFormInput, LoginUserInfo } from 'features/account/types'

// Worker saga
function* onCreateLogin(action: PayloadAction<LoginFormInput>): SagaIterator {
  try {
    const details = yield call(loginCall, action.payload)

    if (details.data.isSuccess === true) {
      localStorage.setItem('token', details?.data?.data?.accessToken)
    } else {
      const user: LoginUserInfo = {
        success: false,
        message: 'Login_Failed',
      }
      yield put(loginActions.loginSucceeded(user))
    }
  } catch (error) {
    const user: LoginUserInfo = {
      success: false,
      message: 'Login_Failed',
    }
    yield put(loginActions.loginSucceeded(user))
  }
}

// Watcher saga
export function* loginWatcherSaga(): SagaIterator {
  yield takeEvery(loginActions.login, onCreateLogin)
}

export default loginWatcherSaga
